import React, { useEffect } from 'react'
import { IMasterInfo } from 'shared/api/mutations'
import { getMasterInfo, ICurriculaInfo } from '../TreeActions'
import { Box, Button } from '@mui/material'
import { getAllCurriculaInfo, updateTreeVersions } from './utility'
import { curriculaUrl } from 'infrastructure/api'
import { openTab } from '../../Helpers'
import { usePrimaryTreeForProduct } from 'shared/api/tree'

export function TrackedCopiesTree({ productId }: { productId: number }) {
  const { tree } = usePrimaryTreeForProduct(productId)
  const [masterInfo, setMasterInfo] = React.useState<IMasterInfo>()

  useEffect(() => {
    if (!tree) return
    getMasterInfo([{ treeId: tree.tree_id, version: tree.version }]).then(
      (resp) => {
        setMasterInfo(Object.values(resp)[0])
      },
    )
  }, [tree])

  if (!tree) return <Box>Loading...</Box>

  return (
    <Box>
      <Box>{tree.title}</Box>
      <Box>{tree.body?.MasterVersionName}</Box>
      <Box>{`${tree.tree_id}:${tree.version}`}</Box>
      {masterInfo && (
        <TrackedCopies
          trackedCopies={masterInfo.copiedTrees}
          canUpdateTo={false}
        />
      )}
    </Box>
  )
}

function TrackedCopies({
  trackedCopies,
  canUpdateTo,
}: {
  trackedCopies: string[]
  canUpdateTo: boolean
}) {
  const [copyData, setCopyData] = React.useState<{
    [key: string]: ICurriculaInfo[]
  }>()
  const [updatedCount, setUpdatedCount] = React.useState(-1)

  function getCopyDetails() {
    getAllCurriculaInfo(trackedCopies, false).then((resp) => {
      setCopyData(resp)
    })
  }

  function updateMissing() {
    if (!copyData || !canUpdateTo) return
    const missing = trackedCopies.filter((ids) => !copyData[ids].length)
    updateTreeVersions(missing).then((resp) => {
      setUpdatedCount(resp.totalAffected)
    })
  }

  function missingCount() {
    if (!copyData || !canUpdateTo) return ''
    const missing = trackedCopies.filter((ids) => !copyData[ids].length)
    return missing.length
  }

  function updateLabel() {
    if (updatedCount < 0) {
      return `Update Missing ${missingCount()}`
    }
    return `Updated ${updatedCount}`
  }

  function goThere(ids: string) {
    openTab(curriculaUrl(ids))
  }
  return (
    <Box>
      <Button disabled={!!copyData} onClick={getCopyDetails}>
        Load Schools
      </Button>
      {canUpdateTo && (
        <Button
          disabled={!copyData || updatedCount >= 0}
          onClick={updateMissing}
        >
          {updateLabel()}
        </Button>
      )}
      {trackedCopies.map((copy) => {
        const copyInfo = copyData?.[copy]
        return (
          <Box key={copy}>
            <Box color={copyInfo?.length === 0 ? 'gray' : ''}>
              {copy}
              <Button onClick={() => goThere(copy)}>GO</Button>
            </Box>
            {!!copyInfo?.length && (
              <Box padding={'10px'}>
                {copyInfo.map((info) => {
                  return (
                    <Box key={info.id}>
                      {info.id}: {info.created_at} {info.deleted && 'Deleted'}
                      <Box padding={'10px'}>
                        Schools:
                        {info.schools.map((school) => {
                          return (
                            <Box key={school.id}>
                              {school.id}: {school.name}
                            </Box>
                          )
                        })}
                      </Box>
                    </Box>
                  )
                })}
              </Box>
            )}
          </Box>
        )
      })}
    </Box>
  )
}
